<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#b0bec5"
      d="M37,17c0,2.945-3.582,7-8,7H19c-4.419,0-8-4.055-8-7l0,0c0-2.945,2-8,13-8l0,0C35,9,37,14.055,37,17L37,17z"
    />
    <path
      fill="#4caf50"
      d="M29,32L29,32H19c0,0-11,1.986-11,13h32C40,34.025,29,32,29,32"
    />
    <path
      fill="#c16e14"
      d="M24,36l-5-4v-6h10v6L24,36z M16,19.277V21l-1.82-1.82C13.485,19.493,13,20.188,13,21c0,1.105,0.895,2,2,2c1.104,0,2-0.895,2-2C17,20.261,16.595,19.623,16,19.277z M33.82,19.18L32,21v-1.723c-0.596,0.346-1,0.984-1,1.723c0,1.105,0.894,2,2,2c1.104,0,2-0.895,2-2C35,20.188,34.515,19.493,33.82,19.18z"
    />
    <path
      fill="#c16e14"
      d="M32,21v-5c0,0,0.635-0.653,0.89-1.937c-0.089-0.389-0.227-0.748-0.417-1.073C31.234,9.502,27.913,7,24,7c-4.313,0-7.913,3.035-8.791,7.085c-0.027,0.058-0.04,0.119-0.062,0.179C15.424,15.419,16,16,16,16v5l-1-1v2c0,3.853,2.425,7.131,5.83,8.415C21.561,31.373,22.702,32,24,32s2.44-0.628,3.17-1.585C30.574,29.131,33,25.853,33,22v-2L32,21z"
    />
    <path
      fill="#1b5e20"
      d="M16,33l3-2l5,5l-5,4L16,33z M32,33l-3-2l-5,5l5,4L32,33z M24,40c0.552,0,1-0.447,1-1s-0.448-1-1-1c-0.553,0-1,0.447-1,1S23.447,40,24,40z M24,44c0.552,0,1-0.447,1-1s-0.448-1-1-1c-0.553,0-1,0.447-1,1S23.447,44,24,44z"
    />
    <path
      fill="#e5852e"
      d="M32,21v-5c0,0,0.635-0.653,0.89-1.937c-0.089-0.389-0.227-0.748-0.417-1.073C31.234,9.502,27.913,7,24,7c-4.313,0-7.913,3.035-8.791,7.085c-0.027,0.058-0.04,0.119-0.062,0.179C15.424,15.419,16,16,16,16v5l-1-1v2c0,3.853,2.425,7.131,5.83,8.415C21.561,31.373,22.702,32,24,32s2.44-0.628,3.17-1.585C30.574,29.131,33,25.853,33,22v-2L32,21z"
    />
    <path
      fill="#3f51b5"
      d="M29,18h-2c-0.84,0-1.557,0.519-1.853,1.254C24.794,19.107,24.407,19,24,19s-0.794,0.107-1.147,0.254C22.557,18.519,21.84,18,21,18h-2c-1.104,0-2,0.894-2,2v2c0,1.105,0.896,2,2,2h2c1.104,0,2-0.895,2-2v-0.539C23.311,21.227,23.714,21,24,21c0.287,0,0.69,0.228,1,0.46V22c0,1.105,0.896,2,2,2h2c1.104,0,2-0.895,2-2v-2C31,18.894,30.104,18,29,18z"
    />
    <path
      fill="#eceff1"
      d="M22,20v2c0,0.551-0.449,1-1,1h-2c-0.551,0-1-0.449-1-1v-2c0-0.551,0.449-1,1-1h2C21.551,19,22,19.449,22,20z M29,19h-2c-0.551,0-1,0.449-1,1v2c0,0.551,0.449,1,1,1h2c0.551,0,1-0.449,1-1v-2C30,19.449,29.551,19,29,19z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "SeniorCitizenIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
